import React from 'react';
import PropTypes from 'prop-types';
import { ApolloProvider, useQuery, gql } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import { get } from 'lodash';
import client from '../../../../lib/apolloClient';
import translations from '../../../../lib/i18n/translations.json';
import CfaHome from '../components/CfaHome';
import Loading from '../../../common/Loading';
import ErrorMessage from '../../../common/ErrorMessage';

const GET_CASH_FLOWS = gql`
  query GetCashFlows {
    cashFlows {
      id
      name
      friendlyName
      createdAt
      cashFlowLength
      numberOfBuyers
      sellerAverageCashFlow
      buyer1AverageCashFlow
      buyer2AverageCashFlow
      purchasePrice
      sellerT12Revenue
      buyer1T12Revenue
      buyer2T12Revenue
      buyer1BreakEven
      buyer2BreakEven
    }
    company {
      id
      name
      host
      cash_flow_analysis_word
      cash_flow_analysis_word_fr
    }
    getCurrentUser {
      id
      name
      email
      motivation
    }
  }
`;

const CfaContainerInner = ({ currentUser, company, features }) => {
  const { loading, error, data } = useQuery(GET_CASH_FLOWS);

  if (loading) return <Loading />;
  if (error) return <ErrorMessage error={error} />;
  
  return (
    <CfaHome
      cashFlows={data.cashFlows}
      company={data.company}
      currentUser={data.getCurrentUser}
      features={features}
    />
  );
};

const CfaContainer = ({ currentUser, company, features }, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  const locale = window.locale;
  return (
    <ApolloProvider client={client}>
      <IntlProvider locale={locale} messages={translations[locale] || translations.en}>
        <CfaContainerInner
          currentUser={currentUser}
          company={company}
          features={features}
        />
      </IntlProvider>
    </ApolloProvider>
  );
};

CfaContainer.propTypes = {
  currentUser: PropTypes.object,
  company: PropTypes.object,
  features: PropTypes.array,
};

export default CfaContainer; 